import script from "./UserWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./UserWidget.vue?vue&type=script&setup=true&lang=js"

import "./UserWidget.vue?vue&type=style&index=0&id=308c8c4b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-308c8c4b"]])

export default __exports__